// require all polyfills based on browserslist with use of babel preset-env builtInt: entry, same as deprecated @babel/polyfill.
// Adds some overhead bundle size-wise, but otherwise we would need
// make sure all node modules are es5 compliant or else transpile them.
// another option would be to provide 2 bundles, one  for modern browsers
// and  another for old ones.

// Do not drop this because the browserslist target looks modern. Scale-app
// devices still in production run Android WebView Chrome 81 and 90 and cannot
// be updated; this import is what covers the APIs they lack. Syntax is not
// covered here and depends on the browserslist target staying wide.

// polyfill only stable features - ES and web standards:
require('core-js/stable');

if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value: function (callback, type, quality) {
      var canvas = this;
      setTimeout(function () {
        var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
          len = binStr.length,
          arr = new Uint8Array(len);

        for (var i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }

        callback(new Blob([arr], { type: type || 'image/png' }));
      });
    }
  });
}
